import { render, staticRenderFns } from "./DropOutText.vue?vue&type=template&id=3d7992b4&lang=pug&"
import script from "./DropOutText.vue?vue&type=script&lang=js&"
export * from "./DropOutText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports